import React from 'react';
import {
  PdsBox,
  PdsMantineIconButton,
  PdsSearchIcon,
  PdsPlusAddIcon,
} from '@podium-design-system/react-components';

/** Hover text for the magnifying-glass action (opens tool selection). */
export const TOOLTIP_RUN_INVESTIGATION_TOOLS =
  'Opens the tools dialog. Choose SecurityTrails, crt.sh, URLScan, and PublicWWW to fetch data for this target and add it as a connected node on the map.';

/** Hover text for the grey + action (map-only). */
export const TOOLTIP_ADD_NODE_TO_MAP_ONLY =
  'Adds this target as a new node on the network map only. No automated external lookups run. Use the Findings tab on that node to add notes, or re-run tools later to pull data.';

/**
 * Blue search (optional) + optional grey + (map-only).
 * Use showInvestigate={false} for contexts where only “add to map” applies (e.g. Findings).
 */
const InvestigatePairButtons = ({
  targetDomain,
  deriveFrom,
  /** Persisted investigation chart edge label (optional); passed to POST trigger/placeholder when set. */
  connectionLabel,
  onRunTools,
  onAddNodeOnly,
  showAddNode = true,
  showInvestigate = true,
  /** Mantine icon button size; use sm+ where the pair should be easier to hit (e.g. Findings). */
  buttonSize = 'xs',
}) => {
  const showSearch = Boolean(showInvestigate && onRunTools);
  const showPlus = Boolean(showAddNode && onAddNodeOnly);
  if (!showSearch && !showPlus) return null;
  return (
    <PdsBox direction="row" gap="xs" alignItems="center" style={{ flexShrink: 0 }}>
      {showSearch && (
        <PdsMantineIconButton
          size={buttonSize}
          rank="fill"
          color="action"
          icon={<PdsSearchIcon />}
          onClick={() => onRunTools(targetDomain, deriveFrom, connectionLabel)}
          aria-label="Run tools for this target"
          title={TOOLTIP_RUN_INVESTIGATION_TOOLS}
        />
      )}
      {showPlus && (
        <PdsMantineIconButton
          size={buttonSize}
          rank="outline"
          color="neutral"
          icon={<PdsPlusAddIcon />}
          onClick={() => onAddNodeOnly(targetDomain, deriveFrom, connectionLabel)}
          aria-label="Add node to map without running tools"
          title={TOOLTIP_ADD_NODE_TO_MAP_ONLY}
        />
      )}
    </PdsBox>
  );
};

export default InvestigatePairButtons;
